// This file should only contain action type constants.

export const SET_LOCATION = 'SET_LOCATION';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';



// WEBPACK FOOTER //
// ./src/actions/types.js